import {Helmet} from "react-helmet"
import {useParams} from 'react-router'
import UserArea from '../Users/UserArea'


const LoginPage = (props) => {
      const {show='login', sid, enc} = useParams()
     return <>
          <Helmet>
          	<title>Login</title>
          </Helmet>
        <UserArea size='large'  show={show} {...props} sid={sid} enc={enc} />
        </>
}


export default LoginPage
